import React, { useState, useId } from 'react';
import { useStyles } from "../styles/styles";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from '@mui/material/Grid';
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";

const Popup = (props) => {
    const open = props.open;
    const setDone = props.setDone;
    const setAgreed = props.setAgreed;
    const component = props.component;
    const agreeText = props.agreeText;
    // Named for what is being agreed to (CPDEV-2847), as Popup is; the generic
    // name is only a fallback.
    const title = props.title || 'Accept Conditions';
    const classes = useStyles;
    // See the note in Popup.jsx: MUI generates an aria-labelledby id that only a
    // DialogTitle would claim, so it has to be given a real target here.
    const titleId = useId();
    const [showCompleted, setShowCompleted] = useState(false);

    return (
        <>
            <Dialog
                open={open}
                maxWidth='md'
                fullWidth
                sx={classes.dialog}
                scroll="paper"
                aria-labelledby={titleId}
                // No aria-describedby -- see Popup.jsx (CPDEV-2842): the body is
                // the whole terms text, which a description reads in one flat run.
                slotProps={{
                    paper: {
                        'aria-label': title
                    }
                }}
            >
                <span id={titleId} style={classes.visuallyHidden}>{title}</span>
                <DialogContent dividers>
                    <DialogContentText component="div">
                        {component}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            alignItems: "top"
                        }}
                    >
                        <Grid size={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="agree"
                                        color='primary'
                                        sx={{marginLeft: {xs: '1rem', md: '1.5rem', lg: '2.5rem'}, paddingBottom: '.5rem'}}
                                        defaultChecked={false}
                                        onChange={(e) => {setAgreed(e.target.checked); setShowCompleted(e.target.checked)}}
                                    />
                                }
                                label={
                                    <Typography variant='subtitle1' color='secondary' sx={{fontSize: {xs: '1rem', sm: '1.2rem'}, lineHeight: {xs: '1rem', sm: '1.2rem'}}}>
                                        {agreeText ? agreeText : 'I agree to these terms and conditions'}
                                    </Typography>
                                }
                                sx={{...classes.checkbox, paddingTop: '1rem'}}
                            />
                        </Grid>
                        <Grid sx={{textAlign: 'right', paddingRight: '3rem'}} size={6}>
                            <Button
                                variant='outlined'
                                color="primary"
                                sx={classes.squashedButton}
                                onClick={() => {setAgreed(false); setDone(true);}}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant='contained'
                                color="primary"
                                sx={classes.squashedButton}
                                disabled={!showCompleted}
                                onClick={() => {setDone(true)}}
                            >
                                Continue
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Popup;
